var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { DefaultToastContainer } from 'react-toast-notifications';
import { mq, styled } from "../utils";
var StyledToastContainer = styled(DefaultToastContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 10000000;\n\n  ", ";\n"], ["\n  z-index: 10000000;\n\n  ",
    ";\n"])), mq({
    padding: [0, '2rem 1rem 0 0', '3rem, 1rem 0 0'],
    width: ['100%', '421px'],
}));
var ToastContainer = function (props) { return (React.createElement(StyledToastContainer, __assign({ "data-component": "ToastContainer" }, props))); };
export default ToastContainer;
var templateObject_1;
//# sourceMappingURL=ToastContainer.js.map